import ReactGA from "react-ga4";

const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

export const initGA = () => {
  if (TRACKING_ID) {
    ReactGA.initialize(TRACKING_ID);
  } else {
    console.error("Google Analytics ID is missing.");
  }
};

export const logPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
